/**
 * Run callback when all window content has loaded
 *
 * @param {function} callback
 */
export function onWindowLoad(callback: () => void) {
    if (document.readyState === 'complete') {
        callback();
    } else {
        window.addEventListener('load', callback);
    }
}
